import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { RouterModule, Routes } from '@angular/router';
import { LexiconModule } from '@galaxy/lexicon';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyPageModule } from '@vendasta/galaxy/page';
import { GalaxyEmptyStateModule } from '@vendasta/galaxy/empty-state';
import baseTranslation from '../../../assets/i18n/en_devel.json';
import { WEBLATE_COMPONENT_NAME } from '../../constants';
import { DateRangeSelectorModule } from '../date-range-selector';
import { AppDialogModule } from '../dialog';
import { CustomOverlayService, GaMetricsModule } from '../ga-metrics';
import { Ga4MetricsModule } from '../ga4-metrics';
import { AnalyticsComponent } from './analytics.component';
import { AnalyticsService } from './analytics.service';
import {
  AnalyticsAreaChartComponent,
  AnalyticsBarChartComponent,
  AnalyticsChartService,
  AnalyticsLineChartComponent,
  AnalyticsPieChartComponent,
} from './charts';

const routes: Routes = [
  {
    path: '',
    component: AnalyticsComponent,
  },
];

@NgModule({
  imports: [
    CommonModule,
    MatCardModule,
    RouterModule.forChild(routes),
    TranslateModule,
    LexiconModule.forChild({
      componentName: WEBLATE_COMPONENT_NAME,
      baseTranslation: baseTranslation,
    }),
    GalaxyEmptyStateModule,
    MatIconModule,
    MatButtonModule,
    GaMetricsModule,
    Ga4MetricsModule,
    MatDatepickerModule,
    MatFormFieldModule,
    DateRangeSelectorModule,
    MatInputModule,
    FormsModule,
    MatProgressSpinnerModule,
    AppDialogModule,
    GalaxyPageModule,
    AnalyticsLineChartComponent,
  ],
  declarations: [
    AnalyticsComponent,
    AnalyticsAreaChartComponent,
    AnalyticsPieChartComponent,
    AnalyticsBarChartComponent,
  ],
  exports: [RouterModule],
  providers: [AnalyticsService, AnalyticsChartService, CustomOverlayService],
})
export class AnalyticsModule {}
